import { render, staticRenderFns } from "./ApplicationContentForm.vue?vue&type=template&id=3b689da8&scoped=true&"
import script from "./ApplicationContentForm.vue?vue&type=script&lang=js&"
export * from "./ApplicationContentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b689da8",
  null
  
)

export default component.exports